<template>
  <notification-drop-down-list-item
    :title="title"
    icon="UploadCloudIcon"
    :color="color"
    @click-ntf="navigateToReport"
  >
    <small>
      {{ message }}
      <br>
      <strong>
        <a
          href="#"
          class="link-plain"
          @click.prevent.stop="navigateToReport">
          {{  $t('ViewAll') }}
        </a>
      </strong>
    </small>
  </notification-drop-down-list-item>
</template>

<script>
// Components
import NotificationDropDownListItem from '@/layouts/components/navbar/components/notifications/NotificationDropDownListItem.vue';

// Mixins
import notificationItemMixin from '@/layouts/components/navbar/components/notifications/mixins/notification-item.mixin';

export default {
  name: 'ImportProcessStartedNotification',
  i18n: {
    messages: {
      en: {
        TitleSuccess: 'Import started',
        MsgSuccess: 'Your {entity} import started successfully.',
        ViewAll: 'View import report',
      },
    },
  },
  components: {
    NotificationDropDownListItem,
  },
  mixins: [notificationItemMixin],
  computed: {
    importId() {
      return this.payload && (this.payload.id || this.payload._id)
        ? this.payload.id || this.payload._id
        : '';
    },
    status() {
      return this.payload && this.payload.status
        ? this.payload.status
        : '';
    },
    entityName() {
      return this.payload && this.payload.entityName
        ? this.payload.entityName
        : '';
    },
    entityMapped() {
      return Object.values(this.$enums.Entity).find(
        (entity) => entity.toLowerCase() === this.entityName.toLowerCase()
          .replace(' ', '')
          .replace('-', ''),
      );
    },
    entityDisplay() {
      const name = this.$tc(`$Entities.${this.entityMapped}`, 2);
      return name ? name.toLowerCase() : '';
    },
    title() {
      return this.$t('TitleSuccess', { entity: this.entityDisplay });
    },
    message() {
      return this.$t('MsgSuccess', { entity: this.entityDisplay });
    },
    color() {
      return 'success';
    },
    to() {
      const queryParam = 'importReport';

      switch (this.entityMapped) {
        case this.$enums.Entity.TAG:
          return `/contacts/tags?${queryParam}=${this.importId}`;

        case this.$enums.Entity.CONTACT:
          return `/contacts/import?${queryParam}=${this.importId}`;

        case this.$enums.Entity.SMS_TEMPLATE:
          return `/sms/templates?${queryParam}=${this.importId}`;

        default:
          return '/';
      }
    },
  },
  methods: {
    navigateToReport() {
      this.$router.push(this.to).catch((err) => {
        // Ignore NavigationDuplicated error
        const isNavigationDuplicated = err.name === 'NavigationDuplicated' ||
          (err.message && err.message.includes('Avoided redundant navigation'));

        if (!isNavigationDuplicated) {
          throw err;
        }
      });
    },
  }
};
</script>

<style scoped>

</style>
